import type { TopDonationWidgetSettings } from './topDonationWidgetSettingsSchema'
import type { Maybe } from '@/types'

export default function getDefaultValues(input?: Maybe<Partial<TopDonationWidgetSettings>>): TopDonationWidgetSettings {
  return {
    darkMode: input?.darkMode ?? true,
    displayNumber: input?.displayNumber ?? 1,
    displayMode: input?.displayMode ?? 'list',
    displayAlignment: input?.displayAlignment ?? 'left',
    headlineText: input?.headlineText ?? 'Höchste Spende',
    headlineFont: input?.headlineFont ?? 'Fira Sans',
    headlineFontWeight: input?.headlineFontWeight ?? 700,
    headlineFontSize: input?.headlineFontSize ?? 32,
    headlineFontColor: input?.headlineFontColor ?? 'ffffff',
    screenNameFont: input?.screenNameFont ?? 'Fira Sans',
    screenNameFontWeight: input?.screenNameFontWeight ?? 400,
    screenNameFontSize: input?.screenNameFontSize ?? 18,
    screenNameFontColor: input?.screenNameFontColor ?? 'ffffff',
    dataFont: input?.dataFont ?? 'Fira Sans',
    dataFontWeight: input?.dataFontWeight ?? 700,
    dataFontSize: input?.dataFontSize ?? 24,
    dataFontColor: input?.dataFontColor ?? '9ECB0A',
    commentFont: input?.commentFont ?? 'Fira Sans',
    commentFontWeight: input?.commentFontWeight ?? 400,
    commentFontSize: input?.commentFontSize ?? 18,
    commentFontColor: input?.commentFontColor ?? 'ffffff',
    shouldShowComment: input?.shouldShowComment ?? true,
  }
}
